import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { LOCALIZED_STRINGS, SPANISH, DEFAULT } from '../constants';
import { white, navy } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc/components/src/typography';

const PartialLanguages = ({
    intl,
    languageId,
    onChangeCallback,
    seeMoreCallback,
}) => {
    const noPreference = intl.formatMessage(LOCALIZED_STRINGS.NoPreference);
    const spanish = intl.formatMessage(LOCALIZED_STRINGS.Spanish);
    const seeMore = intl.formatMessage(LOCALIZED_STRINGS.SeeMore);

    const onChange = update => {
        if (update !== languageId) {
            onChangeCallback({ languageId: update });
        }
    };

    return (
        <div data-test="search-refine-language-filter-partial">
            <RadioGroup
                flush
                name="partial-language"
                onChangeCallback={onChange}
                renderWithoutBox
                selectedValue={languageId}
            >
                <Radio
                    data-test="search-refine-language-filter-partial-noPreference"
                    text={noPreference}
                    value={DEFAULT}
                />
                <Radio
                    data-test="search-refine-language-filter-partial-spanish"
                    text={spanish}
                    value={SPANISH}
                />
            </RadioGroup>
            <SeeMoreDiv
                data-test="search-refine-language-filter-partial-see-more-languages"
                onClick={seeMoreCallback}
            >
                {seeMore}
            </SeeMoreDiv>
        </div>
    );
};

PartialLanguages.propTypes = {
    languageId: PropTypes.string.isRequired,
    onChangeCallback: PropTypes.func.isRequired,
    seeMoreCallback: PropTypes.func.isRequired,
};

const SeeMoreDiv = styled.div`
    font: 15px/24px ${FontFamily.sharpSansSemibold};
    padding: 12px 32px;
    background-color: ${white};
    color: ${navy};
`;

export default injectIntl(PartialLanguages);
